import type {
  TrackingEventStatus,
  TrackingLocation,
  TrackingOverallStatus,
} from "./types";

const OVERALL_LABEL: Record<TrackingOverallStatus, string> = {
  pre_transit: "Accepted",
  in_transit: "In Transit",
  out_for_delivery: "Out for Delivery",
  delivered: "Delivered",
  returned: "Returned",
  undeliverable: "Undeliverable",
};

/** Display label for the overall tracking status. */
export function trackingStatusLabel(status: TrackingOverallStatus): string {
  return OVERALL_LABEL[status] ?? status;
}

const EVENT_LABEL: Record<TrackingEventStatus, string> = {
  processed: "Processed",
  in_transit: "In Transit",
  out_for_delivery: "Out for Delivery",
  delivered: "Delivered",
  returned: "Returned",
  undeliverable: "Undeliverable",
  other: "Scan event",
};

/** Display label for a per-scan event status. */
export function trackingEventStatusLabel(status: TrackingEventStatus): string {
  return EVENT_LABEL[status] ?? status;
}

function titleCase(value: string): string {
  return value.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
}

/** "Atlanta, GA" from a coarse scan location; falls back to ZIP3 / unknown. */
export function formatTrackingLocation(loc: TrackingLocation): string {
  const city = loc.city ? titleCase(loc.city) : null;
  const cityState = [city, loc.state].filter(Boolean).join(", ");
  if (cityState) return cityState;
  return loc.zip3 ? `ZIP ${loc.zip3}` : "Unknown location";
}
